import { Box, Button, ButtonProps } from '@chakra-ui/react';
import { Icon, IconLib, IconMap } from '@common/components/Icon';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from '../components/TextBlock';

interface SidebarMenuItemProps extends ButtonProps {
  icon: keyof typeof IconMap;
  iconVariant?: IconLib;
  route?: string;
  label: string;
  href?: string;
  labelTag?: React.ReactNode;
}

export const SidebarMenuItem = (props: SidebarMenuItemProps) => {
  const { href, icon, iconVariant = 'regular', route, label, labelTag, ...buttonProps } = props;
  const isCurrentRoute =
    route === '/' ? window.location.pathname === '/' : route ? window.location.pathname.startsWith(route) : false;

  return (
    <Button
      as={Link}
      to={route ?? href ?? ''}
      variant="ghost"
      justifyContent="start"
      colorScheme="black"
      fontWeight={'normal'}
      py="2"
      px="4"
      {...buttonProps}>
      <Box display={'flex'} alignItems={'center'} gap="3" width="full">
        <Icon icon={icon} boxSize="16px" color={isCurrentRoute ? 'black' : 'blackAlpha.300'} variant={iconVariant} />
        <TextBlock weight={isCurrentRoute ? 'bold' : 'normal'}>{label}</TextBlock>
        {labelTag}
      </Box>
    </Button>
  );
};
